import { BenefitsForm } from "./BenefitsForm";

const AddBenefit = () => {
  return <BenefitsForm edit={false} />;
};

export { AddBenefit };
